import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const PinIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 17"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M8 10.9318V16.75M12.4339 6.93566L11.8267 1.63616C11.7688 1.13123 11.3414 0.75 10.8332 0.75L5.14186 0.75C4.63366 0.75 4.20628 1.13116 4.14837 1.63605L3.54059 6.93512C3.51434 7.16399 3.40987 7.37679 3.24484 7.53753L2.30227 8.45559C2.10901 8.64383 2 8.90217 2 9.17195V9.93182C2 10.4841 2.44772 10.9318 3 10.9318H13C13.5523 10.9318 14 10.4841 14 9.93182V9.1781C14 8.9047 13.8881 8.64322 13.6902 8.45451L12.7372 7.54542C12.5679 7.38391 12.4606 7.16814 12.4339 6.93566Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

PinIcon.displayName = 'PinIcon';
